var render, staticRenderFns
import script from "./UrlToLink.vue?vue&type=script&lang=js&"
export * from "./UrlToLink.vue?vue&type=script&lang=js&"
import style0 from "./UrlToLink.vue?vue&type=style&index=0&id=b80800c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80800c2",
  null
  
)

export default component.exports